import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  EventEmitter,
  inject,
  input,
  Input,
  Output,
  QueryList,
  ViewChild,
} from '@angular/core';
import { NgbActiveOffcanvas, NgbNav, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { SideSheetContentDirective } from './directives/side-sheet-content.directive';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderWebComponent } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';
import { ImmomioIconName } from '@resident-nx/shared';

@Component({
  standalone: true,
  selector: 'rs-web-side-sheet-form',
  templateUrl: './side-sheet-form.component.html',
  styleUrl: './side-sheet-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'rsWebSideSheetForm',
  imports: [
    NgbNavModule,
    NgTemplateOutlet,
    TranslateModule,
    LoaderWebComponent,
    ImmomioButtonComponent,
    NgClass,
  ],
})
export class SideSheetFormComponent {
  #activeOffCanvas = inject(NgbActiveOffcanvas);
  @Input() showBackButton = true;
  @Input() showNextOrDoneButton = true;
  @Input() loading: boolean;
  @Input() doneButtonText = 'send';
  showNav = input(true);
  @Output() dismiss = new EventEmitter<NgbActiveOffcanvas>();
  @ViewChild('nav') ngbNav: NgbNav;
  @ContentChildren(SideSheetContentDirective)
  contents: QueryList<SideSheetContentDirective>;

  public onDismiss() {
    this.dismiss.emit(this.#activeOffCanvas);
  }

  public nextTab() {
    this.ngbNav.select(this.ngbNav.activeId + 1);
  }

  onNext() {
    this.contents.get(this.ngbNav.activeId).next.emit();
  }

  public onDone() {
    this.contents.get(this.ngbNav.activeId).done.emit(this.#activeOffCanvas);
  }

  protected readonly ImmomioIconName = ImmomioIconName;
}
